export default ['en-us'] as const
